import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  NgZone, OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {FormioComponent, FormioCustomComponent} from '@evi-ui/angular';
import {
  AdditionalDataProvider, ADVANCED_SEARCH_OPERATION,
  CellActionContext,
  CellDataRendererContext,
  CONTEXT_DATA_DRIVEN,
  DisplayFormatter,
  GridColumnDefinition,
  GridOptions,
  LAST_SEARCH_OPERATION,
  mergeGridOptionsWithDefaults, SIMPLE_SEARCH_OPERATION
} from './smart-table.model';
import {HttpClient, HttpParams} from '@angular/common/http';
import {PagedData} from '../../model/paged-data';
import {catchError, concatMap, finalize, map, tap} from 'rxjs/operators';
import * as _ from 'lodash';
import {attachDefaultDisplayFormatter} from './smart-table-cell-formatters';
import {Router} from '@angular/router';
import {DocumentManagementService} from '../../services/document-management.service';
import {attachActionHandler} from './smart-table-action-handlers';
import {LodashTemplateEvaluator} from './LodashTemplateEvaluator';
import {Observable, Observer, of, Subject} from 'rxjs';
import {EventBusService} from '../../event-bus.service';
import {EventType} from '../../model/event.data';
import {trimContent} from '../../utils/format-utils';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AclUtils} from '../../../iam/iam_utils/acl-utils';
import {FormioEvent} from '@evi-ui/angular/elements.common';
import FileSaver from 'file-saver';
import {FileSelectEvent, FileUpload} from 'primeng/fileupload';
import {Document} from '../../model/Document';
import {Formio} from '@evi-ui/js';
import {FormService} from '../../../portal/forms/form.service';
import {EventEmitter as EventEmitter3} from 'eventemitter3';
import {FormRendererUtils} from '../../../portal/application-forms/all-forms-renderer/form-renderer-utils';
import {isNullOrUndefinedOrEmpty} from '@shared/utils/utils';
import {ObjectUtils} from "primeng/utils";
import {IamAuthUtils} from "@shared/utils/iam-auth-utils";
import {
  ShowPopupActionProcessor
} from "@shared/components/custom-action-button/action-processors/show-popup-action-processor";
import {SpinnerUtil} from "@shared/utils/spinner-util";
import {StorageService} from "@shared/services/storage.service";
import {SmartTableLastSearchOperation} from "@shared/components/smart-table/smart-table-last-search-operation";
import {Table} from "primeng/table";
import {IamAppConstants} from "../../../iam/shared/iam-app-constants";

@Component({
  selector: 'smart-table',
  templateUrl: './smart-table.component.html'
})
export class SmartTableComponent
  implements FormioCustomComponent<any>, OnDestroy, OnInit, OnChanges, AfterViewInit {


  destroyRef = inject(DestroyRef);

  smartTableKey: string; // the key of the SmartTable Component in the Form

  @Output()
  valueChange = new EventEmitter<number>();

  eventEmitter = new EventEmitter3();

  @Input()
  disabled: boolean;

  loading: boolean = true;
  paginationPageSizeCurrent = 10;
  isAdvancedFilterVisible = false;

  formattedTitle: any;
  isTitleFormattingRequired = false;
  /*Grid Options defaults*/
  first: number = 0;
  totalRecords: number = 0;
  data: any;
  computedTemplateData: any;
  computedTemplateDataChildTable: any;
  private formioDataSubmission: any;

  private formioInstance: any;
  private formio: any;

  private readonly _searchState: string | null;
  @ViewChild('smartTable', { static: true}) thisTable: Table;

  public get searchState() {
    return this._searchState;
  }

  @ViewChild(FormioComponent) formioComponent: FormioComponent;

  globalSearchOperatorOptions = [
    {
      label: 'Contains',
      icon: 'pi pi-refresh',
      key: 'contains'
    },
    {
      label: 'Starts With',
      icon: 'pi pi-times',
      key: 'starts_with'
    }
  ];

  globalSearchFilterOperator: string = 'contains';
  globalSearchText: string;

  private currentPageLoadEvent: any;

  private advanceSearchQuery: string = '';
  private advanceFilterFields: any[] = [];
  private gridLoaded = false;
  private formDataLoaded = false;

  @Output()
  formioEvent = new EventEmitter<FormioEvent>();

  childRowsData = [];

  public get showPopupActionProcessor() {
    return this._showPopupActionProcessor;
  }

  private _gridOptions!: GridOptions;
  private _qParamFilter!: string;
  private _expansionRowGridOptions!: GridOptions;
  private _value: any = {};

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly ngZone: NgZone,
    private readonly cdr: ChangeDetectorRef,
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2,
    private readonly documentManagementService: DocumentManagementService,
    private readonly formService: FormService,
    private readonly eventBusService: EventBusService,
    private readonly _showPopupActionProcessor: ShowPopupActionProcessor,
    private readonly storageService: StorageService,
  ) {
    console.log(
      `constructor :: in the Smarttable  Component => ${this.smartTableKey}  \n formioInstance => ${this.formioInstance} \n formioDataSubmission => ${this.formioDataSubmission} on => ${new Date()}`
    );

    this.eventBusService
      .on(EventType.FORM_READY)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((formioInstance) => {
        console.log(
          'Received FORM_READY event in  Smart Table ',
          formioInstance
        );
        if (formioInstance == null) {
          return;
        }
        this.attachFormioEventListeners(formioInstance);
        this.formioInstance = formioInstance;
        this.formioDataSubmission = formioInstance;
        this.isAdvancedFilterVisible = true;
        this.toggleAdvancedFilter();
        this.restoreSearchState();
        this.reloadData();
      });

    this.eventBusService
      .on(EventType.FORM_DATA_LOADED)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((formData) => {
        console.log(
          'Received FORM_DATA_LOADED event in  Smart Table ',
          formData
        );
        if (formData == null) {
          //because we are subscribing a behavior Subject with default value as null, first event emitted by default will be null.
          return;
        }
        this.formioDataSubmission = formData;
        this.formDataLoaded = true;
        this.restoreSearchState();
        this.reloadData();
      });

    this.eventBusService
      .on(EventType.API_TEXT_FIELD_DATA_LOADED)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((formData) => {
        if (formData == null) {
          //because we are subscribing a behavior Subject with default value as null, first event emitted by default will be null.
          return;
        }
        if (
          !isNullOrUndefinedOrEmpty(
            this.gridOptions?.ignoreTextWithApiFieldEvents
          ) &&
          !this.gridOptions?.ignoreTextWithApiFieldEvents
        ) {
          // issue fix to data retaining in Court fee table after trying to create subsequent court fee
          this.formioDataSubmission = formData;
          if (this.gridOptions?.triggerDataFetchOnFormDataLoad) {
            this.reloadData();
          }
        }
      });
  }

  ngOnInit() {
    console.log(
      `ngOnInit in the Smarttable  Component => ${this.smartTableKey}  \n formioInstance => ${this.formioInstance} \n formioDataSubmission => ${this.formioDataSubmission} on => ${new Date()}`
    );
  }

  ngOnDestroy() {
    console.log(
      `ngOnDestroy : Smarttable Component => ${this.smartTableKey} on => ${new Date()}`
    );
    try {
      console.log(
        `Destroying the Smarttable => ${this.smartTableKey} , \n formioInstance => ${this.formioInstance} \n formioDataSubmission => ${this.formioDataSubmission}`
      );
      console.log(
        `Destroyed the Smarttable successfully => ${this.smartTableKey} ,`
      );

      this.formioDataSubmission = undefined;
      this.formioInstance = undefined;
      this._value = undefined;
      this.data = undefined;
      this.loading = false;
      this.totalRecords = 0;
      this.first = 0;
    } catch (e) {
      console.error(`Cannot destroy  the Smarttable `, e);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(
      `Smart Table ngOnChanges => ${this.smartTableKey}, changed keys: ${Object.keys(changes).join(', ')}`);
  }

  ngAfterViewInit() {
    if (this.formioComponent) {
      this.formioComponent.formioReady.then((formio) => {
        console.log('formioReady Event in Smart Table');
        this.formio = formio;
      });
    }
  }

  hasAccess(resourceName: string) {
    let hasAccess = true;
    if (resourceName) {
      hasAccess = AclUtils.hasAccess(resourceName);
    }
    return hasAccess;
  }

  public get gridOptions(): any {
    return this._gridOptions;
  }

  @Input()
  public set gridOptions(opts: any) {
    this.updateGridConfiguration(opts);
    if (!this._gridOptions.isListingScreen) { // fix for smart table reloading thrice on Listing screens
      this.triggerGridConfigLoaded();
    }
  }

  get qParamFilter(): string {
    return this._qParamFilter;
  }

  @Input()
  public set expansionRowGridOptions(expansionRowGridOptions: any) {
    this.updateChildGridConfiguration(expansionRowGridOptions);
    if (!this._gridOptions.isListingScreen) { // fix for smart table reloading thrice on Listing screens
      this.triggerGridConfigLoaded();
    }
  }

  public get expansionRowGridOptions(): GridOptions {
    return this._expansionRowGridOptions;
  }

  @Input()
  set qParamFilter(value: string) {
    this._qParamFilter = value;
  }

  public get value() {
    return this._value;
  }

  @Input()
  public set value(val: any) {
    console.log(this._gridOptions.title, 'Data: ', val);
    if (!val) {
      return;
    }
    if (Object.hasOwn(val, 'advanceSearchQuery')) {
      this.globalSearchText = '';
      this.advanceSearchQuery = val.advanceSearchQuery;
      this.advanceFilterFields = val.advanceFilterFields;
      this.currentPageLoadEvent = this.defaultPageLoadEvent();
      let smartTableLastSearchOperation = new SmartTableLastSearchOperation();
      smartTableLastSearchOperation.searchType = ADVANCED_SEARCH_OPERATION;
      smartTableLastSearchOperation.advancedSearchQuery = val.advanceSearchQuery;
      smartTableLastSearchOperation.tableKey = this.smartTableKey;
      smartTableLastSearchOperation.advanceFilterFields = val.advanceFilterFields;
      this.storageService.removeFromLocalStorage(LAST_SEARCH_OPERATION);
      this.storageService.addEntryToLocalStorage(LAST_SEARCH_OPERATION, JSON.stringify(smartTableLastSearchOperation));
      this.first = 0;
      this.currentPageLoadEvent = this.defaultPageLoadEvent();
      this.gridConfigChanged();
      return;
    }
    if (Object.hasOwn(val, 'action') && val.action == 'refresh') {
      console.log('before refresh', this.data);
      this.currentPageLoadEvent = this.defaultPageLoadEvent();
      this.gridConfigChanged();
      return;
    }
    if (Object.hasOwn(val, 'action') && val.action == 'clear') {
      console.log('before clearing data in ', this.smartTableKey, this.data);
      this.data = [];
      if (this._gridOptions.contextDataFieldName && this.formioDataSubmission) {
        _.set(
          this.formioDataSubmission,
          this._gridOptions.contextDataFieldName,
          []
        );
        if (this.formioDataSubmission.data) {
          _.set(
            this.formioDataSubmission.data,
            this._gridOptions.contextDataFieldName,
            []
          );
        }
      }
      this.currentPageLoadEvent = this.defaultPageLoadEvent();
      this.reloadData();
      return;
    }
    if (val.hasOwnProperty('data')) {
      this._value = val.data;
      this.data = val.data;
      this.loading = false;
      this.totalRecords = this.data?.length || 0;
      this.first = 0;
      if (this._gridOptions.contextDataFieldName) {
        _.set(
          this.formioDataSubmission,
          this._gridOptions.contextDataFieldName,
          this.data
        );
      }
      this.reloadData();
    }

  }

  gridConfigChanged() {
    this.reloadData();
  }

  private reloadData() {
    this.loadData(this.getPageLoadEvent());
  }

  localSort($event: any) {
    const field = $event.sortField;
    const order = $event.sortOrder;

    if (field && this.data) {
      this.data.sort((data1, data2) => {
        const value1 = ObjectUtils.resolveFieldData(data1, field);
        const value2 = ObjectUtils.resolveFieldData(data2, field);

        let result: number;

        if (value1 == null && value2 != null) {
          result = -1;
        } else if (value1 != null && value2 == null) {
          result = 1;
        } else if (value1 == null && value2 == null) {
          result = 0;
        } else if (typeof value1 === 'string' && typeof value2 === 'string') {
          result = value1.localeCompare(value2);
        } else if (value1 < value2) {
            result = -1;
        } else if (value1 > value2) {
            result = 1;
        } else {
            result = 0;
        }
        return (order ?? 1) * result;
      });
    }
  }

  loadData($event: any): void {
    // for fields of $event object pls refer -> https://github.com/primefaces/primeng/blob/54cd69fd6d112a932269bf28951954b2bc7a9063/src/app/components/table/table.ts#L2165
    if (isNullOrUndefinedOrEmpty(this._gridOptions)) {
      // avoid triggering reload data if gridConfig is not loaded
      console.log('Not loading Grid Data as gridConfig is undefined');
      return;
    }
    this.disableCDR($event)
      .pipe(
        concatMap(($event) => this.loadDataSeriously($event)),
        concatMap((loadedData) => {

            let additionalDataProviders = this.gridOptions.additionalDataProviders;
            if (additionalDataProviders?.length) {
              return of(null);
            } else {
              return this.compileTemplatesAndUpdateVariables(this.gridOptions, false, loadedData);
            }
          }
        ), // Pass the loaded data as an argument
        tap(() => this.enableCDR()),
        catchError((error) => {
          // Handle any errors that occur during the sequence
          console.error(error);
          return of(null); // Return an observable to continue the sequence even after an error
        }),
        finalize(() => {
          // Perform any final cleanup here
        })
      )
      .subscribe(() => {
        // The sequence is complete
      });
  }

  private disableCDR(data: any): Observable<any> {
    return of(data);
  }

  private compileTemplatesAndUpdateVariables(
    gridOptions: GridOptions,
    isChildTable: boolean,
    data: any[]
  ): Observable<any> {
    // do any formatting based on data here
    if (!isChildTable && this.isTitleFormattingRequired) {
      //performance reasons - title will be hidden until data is loaded if we have to format it blindly only after data loading,
      // which is not looking good in UI. Hence a flag is introduced to check if title required any formatting,
      // if so then we do the formatting after the data is loaded
      let sourceToInterpolate = this.getFormSubmissionContextForInterpolation();
      this.formattedTitle = LodashTemplateEvaluator.interpolate(
        this.gridOptions?.title,
        sourceToInterpolate
      );
    }

    // Use the passed data as an argument
    // Your logic to compile templates and update variables
    if (data && Array.isArray(data)) {
      data?.forEach((rowData, rowIndex, array) => {
        rowData.defaultRendering = [];
        rowData.advancedRendering = [];
        rowData.dynamicDataRowClass = this.evaluateDynamicValue('dynamicDataRowClass', rowData,
          rowIndex,
          gridOptions);

        rowData.dynamicRowPrefix = this.evaluateDynamicValue('dynamicRowPrefix', rowData,
          rowIndex,
          gridOptions);


        gridOptions.columnDefinitions.forEach((columDef, colIndex) => {
          rowData.defaultRendering[colIndex] = this.defaultRendering(
            rowData,
            rowIndex,
            colIndex,
            columDef,
            gridOptions
          );
          rowData.advancedRendering[colIndex] = this.advancedRendering(
            rowData,
            rowIndex,
            colIndex,
            columDef,
            gridOptions
          );
        });

        if (gridOptions.needsRowExpansion && this._expansionRowGridOptions) {
          const rowDatum =
            rowData[<any>this._expansionRowGridOptions.childRowsAttribute];
          if (rowDatum) {
            this.compileTemplatesAndUpdateVariables(
              <any>this._expansionRowGridOptions,
              true,
              rowDatum
            );
          }
        }
      });
    }

    return of(data);
  }

  private enableCDR(): Observable<any> {
    return of(null);
  }

  private updateGridConfiguration(gridOptions: any) {
    if (!gridOptions) return;

    this.smartTableKey = gridOptions.key!;

    this._gridOptions = mergeGridOptionsWithDefaults(gridOptions);

    this._gridOptions.columnDefinitions.forEach((columnDefinition) =>
      attachDefaultDisplayFormatter(columnDefinition)
    );

    if (gridOptions?.title?.indexOf('{{') > -1) {
      // not formatting string present
      this.isTitleFormattingRequired = true;
    }
  }

  private updateChildGridConfiguration(childGridOptions: any) {
    if (!childGridOptions) return;
    this._expansionRowGridOptions = mergeGridOptionsWithDefaults(
      childGridOptions,
      true
    );
    this._expansionRowGridOptions.columnDefinitions.forEach((columnDefinition) =>
      attachDefaultDisplayFormatter(columnDefinition)
    );
  }

  private triggerGridConfigLoaded() {
    this.gridLoaded = true;
    this.reloadData();
  }

  /**
   * method used as hook that executes only after below events are loaded
   * Events - 1. GridConfiguration Updated
   * Events - 2. FormData Loaded
   * @private
   */
  private executeAfterGridAndFormDataLoaded() {
    if (this.gridLoaded && this.formDataLoaded) {
      if (this.gridOptions?.gridDataContext == CONTEXT_DATA_DRIVEN) {
        if (this.data != undefined) {
          console.log(
            this._gridOptions.title,
            'executeAfterGridAndFormDataLoaded: Loading data locally',
            this.data
          );
          this.loadDataLocally({});
        }
      } else if (this._gridOptions?.apiUrl) {
        this.loadDataRemotely({});
      }
    }
  }

  onSelectionChange(selectedData: any[]) {
    let data = selectedData; // use complete row data to store the selection results

    if (!this.gridOptions?.useCompleteRecordDataAsSelection) {
      // pluck the results from the  given field
      _.set(
        this.formioInstance?.submission?.data,
        this.gridOptions?.selectedRecordStorageField + 'Full',
        data
      );
      const identifierField = this.gridOptions?.selectedRecordIdentifierField;
      data = (selectedData ?? []).map((item) =>
        identifierField != null ? _.get(item, identifierField) : item
      );
    }

    _.set(
      this.formioInstance?.submission?.data,
      this.gridOptions?.selectedRecordStorageField,
      data
    );
  }

  changeFilter(operator: string) {
    this.globalSearchFilterOperator = operator;
  }

  filterGlobal(searchText: string, operator: string = 'contains') {
    this.advanceSearchQuery = '';
    let smartTableLastSearchOperation = new SmartTableLastSearchOperation();
    smartTableLastSearchOperation.searchType = SIMPLE_SEARCH_OPERATION;
    smartTableLastSearchOperation.simpleSearchOperator = operator;
    smartTableLastSearchOperation.simpleSearchText = searchText;
    smartTableLastSearchOperation.tableKey = this.smartTableKey;
    this.storageService.removeFromLocalStorage(LAST_SEARCH_OPERATION);
    this.storageService.addEntryToLocalStorage(LAST_SEARCH_OPERATION, JSON.stringify(smartTableLastSearchOperation));
    this.first = 0;
    this.currentPageLoadEvent = this.defaultPageLoadEvent();
    this.reloadData();
  }

  /**
   * adjust the gridlayout class  by toggling the advanced filter of the table
   */
  toggleAdvancedFilter() {
    const smartTableWrapperClassName = 'ifas-smart-table-and-filter-wrapper';
    let smartTableWrapper = this.elementRef.nativeElement.closest(
      `.${smartTableWrapperClassName}`
    );
    if (!smartTableWrapper) {
      console.warn(

        `Wrapper not found with class ${smartTableWrapperClassName}`
      );
      return;
    }

    this.isAdvancedFilterVisible = !this.isAdvancedFilterVisible;

    let tableClass = 'col-md-12';
    let filterClass = 'col-md-0  smart-table-adv-filter-d-none';

    if (this.isAdvancedFilterVisible) {
      tableClass = 'col-md-10';
      filterClass = 'col-md-2   smart-table-adv-filter-d-block';
    }
    this.renderer.setAttribute(
      smartTableWrapper.children[0],
      'class',
      tableClass
    );
    this.renderer.setAttribute(
      smartTableWrapper.children[1],
      'class',
      filterClass
    );
  }

  handleGridAction(
    rowData: any,
    actionableHTMLFragments: ActionableHTMLFragment
  ) {
    attachActionHandler(actionableHTMLFragments.displayFormatter);

    let cellActionContext = {
      rowData: rowData,
      router: this.router,
      downloadService: this.documentManagementService,
      gridOptions: this._gridOptions,
      actionValue: actionableHTMLFragments.value,
      gridData: this.data,
      formioDataSubmission: this.getFormSubmissionContextForInterpolation(),
      formioInstance: this.formioInstance,
      smartTableInstance: this,
      formioEvent: this.formioEvent
    };
    actionableHTMLFragments.displayFormatter.handler?.(
      <CellActionContext>cellActionContext,
      actionableHTMLFragments.displayFormatter
    );
  }

  tooltipValueGetter(rowData: any, columnDef: GridColumnDefinition) {
    let cellData = columnDef?.field ? _.get(rowData, columnDef.field) : '';
    return cellData;
  }

  private getPageLoadEvent(): any {
    return this.currentPageLoadEvent
      ? this.currentPageLoadEvent
      : this.defaultPageLoadEvent();
  }

  private defaultPageLoadEvent(): any {
    return {first: 0, rows: this.paginationPageSizeCurrent};
  }

  private loadDataSeriously($event: any): Observable<any> {
    if (this.gridOptions?.defaultData?.length) {
      return this.populateStaticData();
    } else if (this.gridOptions?.gridDataContext == CONTEXT_DATA_DRIVEN) {
      console.log(
        this._gridOptions.title,
        'loadDataSeriously: Loading data locally',
        this.data
      );
      return this.loadDataLocally($event);
    } else {
      // API DRIVEN
      return this.loadDataRemotely($event);
    }
  }

  public getColspan(gridOptions, childGridOptions): any {

    let columnDefinitionsLength = childGridOptions?.rowSpanCount || gridOptions?.columnDefinitions?.length || 0;

    if (childGridOptions?.checkboxSelection || childGridOptions?.needsRowExpansion) {
      columnDefinitionsLength++;
    }

    if (childGridOptions?.slnoColumnRequired) {
      columnDefinitionsLength++;
    }
    return columnDefinitionsLength;
  }

  private computeValue(
    columnDef: GridColumnDefinition,
    rowData: any,
    gridOptions: GridOptions
  ): string | null | undefined {
    let cellData =
      columnDef?.field && columnDef?.compositeColumn
        ? null
        : _.get(rowData, columnDef?.field);

    if (columnDef?.valueFormatterTemplate) {
      //apply value Formatter
      cellData = LodashTemplateEvaluator.interpolate(
        columnDef?.valueFormatterTemplate,
        {
          rowData: rowData,
          gridOptions: gridOptions
        }
      );
    }
    return cellData;
  }

  private evaluateDynamicValue(attributeName: any, rowData: any,
                               rowIndex: number,
                               gridOptions: GridOptions) {
    let attributeValue: string | undefined | null = '';
    if (gridOptions?.[attributeName]) {
      attributeValue = LodashTemplateEvaluator.interpolate(
        gridOptions?.[attributeName],
        {
          rowData: rowData,
          rowIndex: rowIndex,
          gridOptions: gridOptions
        }
      );
    }

    return attributeValue;
  }

  private defaultRendering(
    rowData: any,
    rowIndex: number,
    colIndex: number,
    columnDef: GridColumnDefinition,
    gridOptions: GridOptions
  ): any {
    let cellData = this.computeValue(columnDef, rowData, gridOptions);

    let cellDataRendererContext: CellDataRendererContext = {
      index: colIndex,
      rowData: rowData,
      columnDef: columnDef,
      rowIndex
    };
    let formattedData = columnDef?.defaultDisplayFormatter?.(
      cellData,
      cellDataRendererContext
    );

    return formattedData;
  }

  /**
   * Renders the data and attach the actions based on the DisplayValue Formatters assigned to the Grid Column
   * @param rowData
   * @param index
   * @param columnDef
   */
  // NOSONAR
  private advancedRendering(
    rowData: any,
    rowIndex: number,
    colIndex: number, // NOSONAR
    columnDef: GridColumnDefinition,
    gridOptions: GridOptions
  ): ActionableHTMLFragment[] { // NOSONAR
    let actionableHTMLFragmentList: ActionableHTMLFragment[] = [];

    // 1. compute the value of cell. Can be raw value or value from a  Value Formatter
    let cellData = this.computeValue(columnDef, rowData, gridOptions);

    if (columnDef?.displayValueFormatters?.length == 0) {
      return actionableHTMLFragmentList;
    }
    // 2. iterate through the display Value Formatters - remember, advanced rendering is invoked from template only when there is at least one display Formatter defined
    columnDef?.displayValueFormatters?.forEach((displayFormatter, i) => { // NOSONAR
      //2.1 get the formatted display Value

      let displayValue: string | undefined | null = '';
      if (displayFormatter?.displayValueFormatterTemplate) { // NOSONAR
        displayValue = LodashTemplateEvaluator.interpolate(
          displayFormatter.displayValueFormatterTemplate,
          {
            rowData: rowData,
            data: cellData,
            gridOptions: gridOptions
          }
        );
      }

      // prepare the HTML Fragment responsible for rendering and  passing the action params
      let actionableHTMLFragment: ActionableHTMLFragment = {
        value: cellData,
        displayValue: trimContent(displayValue),
        displayFormatter: displayFormatter,
        disabled: null,
        toolTip: displayFormatter.toolTip
      };

      // Associate the action value
      if ( // NOSONAR
        displayFormatter?.category && // NOSONAR
        displayFormatter.category !== 'no_action'
      ) {
        let actionValue: string | null | undefined = null;
        if (displayFormatter?.actionValueFormatterTemplate) { // NOSONAR
          actionValue = LodashTemplateEvaluator.interpolate(
            displayFormatter?.actionValueFormatterTemplate,
            {
              rowData: rowData,
              data: cellData,
              submissionData:
              this.formioDataSubmission
                ?.data /*when context data driven is used, there were use cases to refer the complete submission data to deduce the business logic */,
              gridOptions: gridOptions
            }
          );
        } else { // NOSONAR
          switch (displayFormatter?.category) { // NOSONAR
            case 'navigation':
              actionValue = displayFormatter?.actionUrl;
              break;
            case 'popup':
              actionValue = displayFormatter?.popupScreenId;
              break;
            case 'download':
              actionValue = displayFormatter?.downloadId;
              break;
            case 'delete_row':
            case 'edit_row':
              actionValue = '' + rowIndex; //row index
              break;
          }
        }
        actionableHTMLFragment.value = trimContent(actionValue);
        if (actionableHTMLFragment?.displayFormatter?.conditionallyDisable) { // NOSONAR
          let scriptValue = LodashTemplateEvaluator.interpolate(
            actionableHTMLFragment?.displayFormatter?.conditionallyDisable,
            {
              rowData: rowData,
              submissionData: this.formioDataSubmission?.data
            }
          );
          let shouldDisable = FormRendererUtils.evaluate(
            scriptValue,
            {
              rowData: rowData,
              submissionData:
                this.formioDataSubmission?.hasOwnProperty('data')
                  ? this.formioDataSubmission.data // NOSONAR
                  : this.formioDataSubmission
            },
            'disable',
            true
          );
          if (shouldDisable) { // NOSONAR
            actionableHTMLFragment.disabled = 'disabled';
            actionableHTMLFragment.toolTip =
              actionableHTMLFragment?.displayFormatter?.toolTipWhenDisabled || // NOSONAR
              '';
          }
        }
      }
      actionableHTMLFragmentList.push(actionableHTMLFragment);
    });

    return actionableHTMLFragmentList;
  }

  refreshGrid() {
    this.storageService.removeFromLocalStorage(LAST_SEARCH_OPERATION)
    this.globalSearchText = '';
    this.first = 0;
    this.currentPageLoadEvent = this.defaultPageLoadEvent();
    this.advanceSearchQuery = '';
    this.advanceFilterFields = [];
    this.reloadData();
  }

  // NOSONAR
  private loadDataRemotely($event: any): Observable<any> { // NOSONAR
    const config = {};
    //pagination
    config['page'] = $event.first / $event.rows + 1;
    config['size'] = $event.rows;

    //sorting
    if ($event.sortField) {
      let sort = $event.sortField;
      sort = sort + ',' + ($event.sortOrder > 0 ? 'asc' : 'desc');
      config['sort'] = sort;
    } else if (
      this.gridOptions?.defaultSort &&
      !_.isEmpty(this.gridOptions?.defaultSort)
    ) {
      config['sort'] = this.gridOptions.defaultSort;
    }

    let searchQueryParam = '';
    // q param
    if (
      this.gridOptions?.globalSearchEnabled &&
      !_.isNil(this.globalSearchText) &&
      !_.isEmpty(this.globalSearchText) &&
      !_.isEmpty(this._gridOptions?.globalSearchQueryFormatter)
    ) {
      let searchValue =
        this.globalSearchFilterOperator == 'starts_with'
          ? `[${this.globalSearchText})`
          : `(%${this.globalSearchText}%)`;
      //apply value Formatter
      searchQueryParam = LodashTemplateEvaluator.interpolate(
        this._gridOptions?.globalSearchQueryFormatter,
        {
          searchText: searchValue,
          gridOptions: this.gridOptions
        }
      );
    }
    let urlToUse = <string>this._gridOptions.apiUrl;

    if (!_.isEmpty(searchQueryParam)) {
      let url = this.getURLObject(urlToUse); // url be like => http://localhost:4200/api/core/suspense-account-transactions?q=status:PENDING_ACTION%20|%20PARTIALLY_RESOLVED
      let defaultQparam = '';
      if (!isNullOrUndefinedOrEmpty(url.searchParams.get('q'))) {
        console.debug(`Default q Param => ${url.searchParams.get('q')}`); //return value be like => status:PENDING_ACTION%20|%20PARTIALLY_RESOLVED
        defaultQparam = url.searchParams.get('q') + ';';
        urlToUse = url.pathname;
      }
      config['q'] = defaultQparam + searchQueryParam;
      console.debug(
        `Q Params => default [${defaultQparam}] , SearchParams [${searchQueryParam}] final qParam [${config['q']}]`
      );
    }

    let params = new HttpParams();

    Object.keys(config).forEach((key) => {
      params = params.set(key, config[key]);
    });

    if (!this._gridOptions?.apiUrl) {
      console.error('Grid API Url not populated');
      return of(null);
    }

    if (!_.isEmpty(this.advanceSearchQuery)) {
      //check Advanced filter
      urlToUse += this.advanceSearchQuery;
    }

    let sourceToInterpolate = this.getFormSubmissionContextForInterpolation();

    urlToUse = LodashTemplateEvaluator.interpolate(
      urlToUse,
      sourceToInterpolate
    );
    urlToUse = encodeURI(urlToUse);


    return this.http
      .get<PagedData<any>>(urlToUse, { // NOSONAR
        params: params
      })
      .pipe(
        map((res) => { // NOSONAR
          this.loading = false;

          const responseData = _.isEqual(
            this.gridOptions.pageDataFieldName,
            '*'
          )
            ? res
            : res[this.gridOptions.pageDataFieldName];

          this.data = responseData;
          let additionalDataProviders = this.gridOptions.additionalDataProviders;
          if (additionalDataProviders?.length) {
            let additionalResponse = {};
            const formDataLoaded$ = new Subject();
            this.fetchAdditionalData(additionalDataProviders, 0, additionalResponse, formDataLoaded$, responseData);
            formDataLoaded$
              .asObservable()
              .pipe(takeUntilDestroyed(this.destroyRef))
              // NOSONAR
              .subscribe((additionalApiResponse) => { // NOSONAR
                  console.log('additionalApiResponse: ', additionalApiResponse);
                  for (const additionalDataProvider of additionalDataProviders) {
                    if (additionalDataProvider.responseAction == 'MERGE') {
                      let propertyName = additionalDataProvider.gridFieldToStoreResult!!;
                      let keyInGridData = additionalDataProvider.gridKeyToUseForMerging;
                      // @ts-ignore
                      let dataInAdditionalApiResponse = additionalApiResponse[propertyName];
                      if (dataInAdditionalApiResponse.hasOwnProperty("apiError")) {
                        //Ignore and continue if any of the API errored-out
                        continue;
                      }
                      let responseKeyToUseForMerging = additionalDataProvider.responseKeyToUseForMerging;
                      responseData.forEach(rowData => { // NOSONAR
                        let dataForThisRow = dataInAdditionalApiResponse.filter(x => x[responseKeyToUseForMerging] == rowData[keyInGridData]); // NOSONAR
                        if (dataForThisRow?.length) {
                          rowData[propertyName] = dataForThisRow[0];
                        }
                      });
                    }
                  }
                  //Re-render the table after additional data is fetched.
                  this.compileTemplatesAndUpdateVariables(
                    this.gridOptions,
                    false,
                    responseData
                  )
                },
                (error) => {
                  console.log(error);
                  this.compileTemplatesAndUpdateVariables(
                    this.gridOptions,
                    false,
                    responseData
                  )
                })
          }
          this.totalRecords = res?.totalElements || 0;
          this.first = res?.first ? 0 : this.first;

          return responseData;
        })
      );
  }

  private restoreSearchState() {

    let lastSearchOperationJson = this.storageService.getEntryFromLocalStorage(LAST_SEARCH_OPERATION);
    if (!lastSearchOperationJson) {
      console.log('No lastSearchOperation found');
      return;
    }
    let lastSearchOperation: SmartTableLastSearchOperation = JSON.parse(lastSearchOperationJson);

    let isLastSearchOperationForThisTable = lastSearchOperation.tableKey === this.smartTableKey;
    isLastSearchOperationForThisTable = isLastSearchOperationForThisTable || (lastSearchOperation.tableKey === this._gridOptions?.key);

    if (!isLastSearchOperationForThisTable) {
      console.log("No stored search query found for " + this.smartTableKey + ". Found " + lastSearchOperation.tableKey + " or " + this._gridOptions?.key);
      return;
    }
    if (lastSearchOperation.searchType === SIMPLE_SEARCH_OPERATION) {

      this.globalSearchFilterOperator = lastSearchOperation.simpleSearchOperator!!;
      this.globalSearchText = lastSearchOperation.simpleSearchText!!;
      // Decode Base64 string back to JSON string
    } else if (lastSearchOperation.searchType === ADVANCED_SEARCH_OPERATION && lastSearchOperation.advancedSearchQuery) {
      this.advanceSearchQuery = lastSearchOperation.advancedSearchQuery;
      this.setValuesFromAdvanceFilterFields(this.formioDataSubmission, lastSearchOperation.advanceFilterFields);
    }

    if (lastSearchOperation?.rows && lastSearchOperation?.first) {
      this.paginationPageSizeCurrent = lastSearchOperation.rows;
      this.first = lastSearchOperation.first;
      this.currentPageLoadEvent = {
        first: this.first,
        rows: this.paginationPageSizeCurrent
      };
    }
  }

  private hasNonEmptyAdvanceFilter(advanceFilterFields) {
    return _.some(advanceFilterFields, (field) => !_.isEmpty(field.value));
  }

  private setValuesFromAdvanceFilterFields(formioInstance, advanceFilterFields) {
    if (this.hasNonEmptyAdvanceFilter(advanceFilterFields)) {
      // Iterate through the advanceFilterFields
      advanceFilterFields.forEach((field) => {
        if (field.key && field.value) {
          // Use the Formio API to set the value for the matching key
          console.log(`setting the filed value in advanced filter ${field.key} => ${field.value}`)
          _.set(formioInstance.submission.data, field.key, field.value);
          let component = FormRendererUtils.getComponent(field.key, formioInstance.components);
          component.redraw();
        }
      });
      this.toggleAdvancedFilter();
    }

  }

  private getURLObject(urlToUse: string): URL {
    const url = new URL(urlToUse, globalThis.location.origin);
    return url;
  }

  protected getFormSubmissionContextForInterpolation() {
    const propagatedState = _.get(this.formioDataSubmission, 'propagatedState');
    if (!_.isEmpty(propagatedState)) {
      return this.formioDataSubmission;
    }

    const dataPropagatedState = _.get(this.formioDataSubmission, 'data.propagatedState');
    if (!_.isEmpty(dataPropagatedState)) {
      return this.formioDataSubmission.data;
    }

    const data = _.get(this.formioDataSubmission, 'data');
    if (!_.isEmpty(data)) {
      return this.formioDataSubmission.data;
    }

    const submissionData = _.get(this.formioInstance, 'submission.data');
    if (!_.isEmpty(submissionData)) {
      return submissionData;
    }

    return this.formioDataSubmission;
  }

  private loadDataLocally($event: any, useDataFromSubmission: boolean = true) {
    console.log(this._gridOptions.title, 'ENTRY: loadDataLocally', this.data);
    if (this.formioDataSubmission) {
      if (useDataFromSubmission) {
        this.data = _.cloneDeep( // NOSONAR: structuredClone breaks Angular form state
          _.get(
            this.formioDataSubmission,
            this.gridOptions.contextDataFieldName
          )
        );
        if (!this.data && this.formioDataSubmission?.data) {
          this.data = _.cloneDeep( // NOSONAR: structuredClone breaks Angular form state
            _.get(
              this.formioDataSubmission.data,
              this.gridOptions.contextDataFieldName
            )
          );
        }
      }
      this.loading = false;
      this.totalRecords = this.data?.length || 0;
      this.first = 0;
      this.localSort($event);
      return of(this.data);
    } else {
      return of(null);
    }
  }

  private populateStaticData() {
    this.loading = false;
    this.data = this.gridOptions?.defaultData;
    this.totalRecords = this.data?.length || 0;
    this.first = 0;
    return of(this.data);
  }

  exportExcel() {
    import('xlsx').then((xlsx) => {
      const xlData = _.cloneDeep(this.data); // NOSONAR: structuredClone breaks Angular form state

      delete xlData['advancedRendering'];
      delete xlData['defaultRendering'];
      let xlsxJsonData = this.transformDataToExcel(xlData);
      const worksheet = xlsx.utils.json_to_sheet(xlsxJsonData);
      const workbook = {Sheets: {data: worksheet}, SheetNames: ['Data']};
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      this.saveAsExcelFile(
        excelBuffer,
        this.formattedTitle || this._gridOptions.title
      );
    });
  }

  saveAsExcelFile(buffer: any, fileName: string | undefined): void {
    let EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(
      data,
      fileName + '_export_' + Date.now() + EXCEL_EXTENSION
    );
  }

  documentUpload(event: any, fileUpload: FileUpload) {
    for (const file of event.files) {
      URL.createObjectURL(file);
      // @ts-ignore
      this.uploadDocument(file, this.maxFileSize).subscribe(
        (documentData: Document) => {
          console.log('Documents uploaded in smart table-> ', documentData);
          this.formioInstance.submission.data['importFileId'] = documentData.id;
          this.formioInstance.submission.data['importFileName'] = file.name;

          this.triggerParsing(file);

        }
      );
    }
    fileUpload.clear();
  }

  emit(eventName, payload) {
    console.log('Emitting event from smart table -> ' + eventName);
    this.formioEvent.emit({
      eventName,
      data: payload
    });
  }

  uploadDocument(file: File, maxFileSize: number) {
    if (file.size > maxFileSize) {
      return;
    }
    const fileToSave: Document = new Document();
    fileToSave.fileName = file.name;
    fileToSave.fileSize = file.size;
    fileToSave.fileType = file.type;
    const formData: FormData = new FormData();
    formData.append(
      'documentJson',
      new Blob([JSON.stringify(fileToSave)], {
        type: 'application/json'
      })
    );
    formData.append('file', file);
    return this.documentManagementService.createDocument(formData);
  }

  onFileSelect($event: FileSelectEvent, fileUpload: FileUpload) {
    this.documentUpload($event, fileUpload);
    debugger;
  }

  onPageChange(event: any) {
    let lastSearchOperationJson = this.storageService.getEntryFromLocalStorage(LAST_SEARCH_OPERATION);

    let lastSearchOperation: SmartTableLastSearchOperation = lastSearchOperationJson ? JSON.parse(lastSearchOperationJson)
      : new SmartTableLastSearchOperation();
    if (lastSearchOperation.tableKey != this.smartTableKey) { //To ensure we have search operation for current table.
      lastSearchOperation = new SmartTableLastSearchOperation();
    }
    lastSearchOperation.tableKey = this.smartTableKey;
    lastSearchOperation.first = event.first;
    lastSearchOperation.rows = event.rows;
    this.storageService.addEntryToLocalStorage(LAST_SEARCH_OPERATION, JSON.stringify(lastSearchOperation));

  }

  private transformDataToExcel(xlData: any) {
    let jsonRowData: any[] = [];
    let headerNames: any[] = [];
    this._gridOptions.columnDefinitions.forEach(
      (columnDef) =>
        columnDef.field &&
        headerNames.push({
          fieldName: columnDef.field,
          fieldValue: columnDef.headerName
        })
    );

    let entry = {};
    headerNames.forEach((header) => {
      entry[header.fieldName] = header.fieldValue;
    });

    jsonRowData.push(entry);

    xlData.forEach((dataEntry, i) => {
      let entry = {};
      entry['index'] = i;

      headerNames.forEach((header) => {
        entry[header.fieldName] = _.get(dataEntry, header.fieldName);
      });
      jsonRowData.push(entry);
    });

    return jsonRowData;
  }

  private triggerParsing(file: any) {
    const providerFunction = (Formio as any).Providers.getProvider(
      'parser',
      this._gridOptions.parser
    );

    if (providerFunction) {
      const fileParsingContext = {
        file: file,
        fileInfo: undefined,
        component: this.gridOptions,
        submission: this.formioDataSubmission,
        componentContext: this
      };
      providerFunction().parse(fileParsingContext);
    }
  }

  private attachFormioEventListeners(formio: any) {
    formio.on('fileParsingCompleted', () => {
      console.log('fileParsingCompleted event captured in smart table');
      this.onFileParsingCompleted();
    });
  }

  private onFileParsingCompleted() {

    if (this._gridOptions?.parserResultField && !isNullOrUndefinedOrEmpty(this._gridOptions?.parserResultField)
      && this.formioInstance?.submission?.data) {
      const gridData =
        this.formioInstance.submission.data[this._gridOptions.parserResultField];
      this.formioInstance.submission.data['parsedResults'] = gridData;
      this.reloadData();
      this.validateImportedData();
    }
  }

  private validateImportedData() {
    let _self;
    const importFormId = this._gridOptions.importFormId;
    this.formService.getById(importFormId).subscribe((data) => {
      if (typeof data?.components?.[0] === 'string') {
        const form: any = {};
        form.components = JSON.parse(data.components[0]);

        Formio.Headers(
          new Headers({
            Authorization: 'Bearer ' + IamAuthUtils.getCurrentUserToken()
          })
        );
        //This tokens object will be used by XHR requests from within the JS framework to append the headers on request.
        // @ts-ignore
        Formio.tokens = {
          Authorization: 'Bearer ' + IamAuthUtils.getCurrentUserToken()
        };
        const formElement = document.createElement('div');
        Formio.createForm(formElement, {
          components: form.components
        }).then((form) => {
          const gridData =
            this.formioInstance.submission.data[
              this._gridOptions.parserResultField
              ];
          debugger;
          gridData.map((entry) => {
            debugger;
            const checkValidity = form.checkValidity(entry, true, entry);
            console.log('validity => ' + checkValidity);
          });

          this.formioInstance.submission.data['canImport'] = true;
          this.emit('enable-process-import-event', {
            data: {}
          });
        });
      }
    });
  }

  private fetchAdditionalData(
    additionalUrlsToFetch: AdditionalDataProvider[],
    currentIndex: number,
    dataAccumulator: any,
    formDataLoaded$: Observer<any>,
    gridApiResponse: any
  ) {
    SpinnerUtil.activateSpinner();
    const _self = this;   // NOSONAR
    let urlToFetch = additionalUrlsToFetch[currentIndex].apiUrl;
    const apiMethod = additionalUrlsToFetch[currentIndex].apiMethod;
    urlToFetch = FormRendererUtils.resolveRepeatingParameters(
      urlToFetch,
      dataAccumulator
    );

    urlToFetch = LodashTemplateEvaluator.interpolate(
      urlToFetch,
      dataAccumulator
    );

    for (const columnKey of additionalUrlsToFetch[currentIndex].columnToKeyMapping) {
      let gridKey = columnKey['parentGridPropertyName'];
      let responseKey = columnKey['keyInDataProvider'];
      console.log('gridKey: ', gridKey, 'responseKey: ', responseKey);
      let valuesFromGrid = gridApiResponse.map(x => x[gridKey]).join('|');
      urlToFetch = urlToFetch.replace("{{" + responseKey + "}}", valuesFromGrid);
    }

    /**
     * lambda to handle the api result in the API call chain
     * @param result
     */
    const handleAPICallResult = (result) => {
      if (result) {
        // if results are valid accumulate  the results
        let propertyName = additionalUrlsToFetch[currentIndex].fieldNameToStoreResult;
        if (!propertyName) {
          propertyName = additionalUrlsToFetch[currentIndex].gridFieldToStoreResult!!;
        }
        const dataPath = additionalUrlsToFetch[currentIndex].dataPath;
        dataAccumulator[propertyName] =
          _.isUndefined(dataPath) || _.isEmpty(dataPath)
            ? result
            : _.get(result, dataPath);
      }
      if (currentIndex + 1 == additionalUrlsToFetch.length) {
        // final api call in the chain ??
        formDataLoaded$.next(dataAccumulator);
        SpinnerUtil.deactivateSpinner();
        return; // NOSONAR
      } else {
        // still have chain of calls to process, hence proceed with next API call in the chain
        return _self.fetchAdditionalData(
          additionalUrlsToFetch,
          currentIndex + 1,
          dataAccumulator,
          formDataLoaded$,
          gridApiResponse
        );
      }
    };

    let requestBody = additionalUrlsToFetch[currentIndex].apiRequest;
    if (!_.isEmpty(requestBody)) {
      requestBody = LodashTemplateEvaluator.interpolate(requestBody, {});
    }

    if (urlToFetch) {
      // ensure its a valid api, after interpolation
      Formio.fetch(urlToFetch, this.getRequest(apiMethod, requestBody)).then(function (response) {
        if (response.status && ('' + response.status).startsWith('2')) {
          response.json().then(function (result) {
            return handleAPICallResult(result); // handle the result after the api is returned
          });
        } else {
          console.log('Received non 2xx for ', urlToFetch, '. Response is ', response);
          return handleAPICallResult({
            apiError: response
          });
        }
      }).catch((error) => {
        console.log(urlToFetch, 'failed', error);
        return handleAPICallResult({
          apiError: error
        });
      });
    } else {
      // invalid api in the call chain, so proceed further in the API call chain, thinking as if the api results are null
      return handleAPICallResult(null);
    }
  }

  private getRequest(apiMethod: string, requestBody?: string) {
    if (apiMethod == 'GET') {
      return "{" +
        "      headers: {" +
        "        'content-type': 'application/json'," +
        "          Authorization: 'Bearer ' " + IamAuthUtils.getCurrentUserToken() +
        "      }," +
        "      method: " + apiMethod +
        ",     cache: 'no-store'" +
        "    }";
    } else {
      return "{" +
        "      headers: {" +
        "        'content-type': 'application/json'," +
        "          Authorization: 'Bearer ' " + IamAuthUtils.getCurrentUserToken() +
        "      }," +
        "      method: " + apiMethod +
        ",     body: " + requestBody +
        ",     cache: 'no-store'" +
        "    }";
    }
  }

  handleDropdownKey(event: any) {
    return IamAppConstants.handleDropdownKey(event);
  }

}

export interface ActionableHTMLFragment {
  value?: string | null;
  displayValue?: string | null;
  displayFormatter: DisplayFormatter; //This is used only for holding configuration. The values from this cannot be used to render dynamic values.
  disabled: any;
  toolTip: string;
}
